<template lang="pug">
div
  .icon.is-small
    i.fas.fa-sync(v-on:click="impl")
</template>

<script>
export default {
  props: {
    impl: {
      required: true,
      type: Function
    }
  }
}
</script>
